import { Container, Tabs, Text } from "@postenbring/hedwig-react";
export const TitleAndTab = ({ title, current, links }) => {
    const handleTabChange = (url) => {
        window.location.href =  url;
    }
    return (
        <Container>
            <Text variant="h1">{title}</Text>
            <div className="hds-mb-32-40">
            <Tabs defaultTab={current}>
                <Tabs.List>
                    {links.map((link) => (
                        <Tabs.Tab key={link.id} tabId={link.id} onClick={() => handleTabChange(link.url)}>{link.text}</Tabs.Tab>
                    ))}
                </Tabs.List>
            </Tabs>
            </div>
        </Container >
    )
}   